import { Button } from '@components/core-ui/form-elements/buttons/Button/';

import { pluralize } from '@helpers/pluralize';
import { DiffMethod } from 'react-diff-viewer-continued';

import { Diff } from './components/Diff';
import { TProps } from './types/TProps';

export const SecondStage = ({ left, right, setStage }: TProps) => {
  const leftLines = left.split('\n').length ?? 0;
  const rightLines = right.split('\n').length ?? 0;
  return (
    <div className="second-stage">
      <div className="flex-block">
        <div className="left-wrapper">
          <div className="lines">
            {leftLines} {pluralize(leftLines, 'line', `lines`)}
          </div>
        </div>
        <div className="right-wrapper">
          <div className="lines">
            {rightLines} {pluralize(rightLines, 'line', `lines`)}
          </div>
        </div>
      </div>
      <div className="diff">
        <Diff left={left} right={right} method={DiffMethod.WORDS_WITH_SPACE} />
      </div>
      <Button
        onClick={() => {
          // setReference('');
          // setHypotesis('');
          setStage(1);
        }}
      >
        Try again
      </Button>
    </div>
  );
};
